// Parse a CSS declaration string into a React style object so the markup
// from the original template can be carried over near-verbatim.
export function s(css) {
  const obj = {};
  for (const rule of css.split(";")) {
    const i = rule.indexOf(":");
    if (i === -1) continue;
    const key = rule.slice(0, i).trim();
    const val = rule.slice(i + 1).trim();
    if (!key) continue;
    const jsKey = key.startsWith("--")
      ? key
      : key.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
    obj[jsKey] = val;
  }
  return obj;
}
